import type { Batch } from "@/api/client";

// Certificates exist once a batch is approved.
export const ISSUED_STATUSES: readonly Batch["status"][] = ["approved", "generating", "generated", "failed", "distributing", "completed"];

// The API spools only a batch that has finished generating (409 otherwise).
export const PRINTABLE_STATUSES: readonly Batch["status"][] = ["generated", "failed", "distributing", "completed"];
